<vdr-page-body>
  <form
    class="form"
    [formGroup]="detailForm"
    (ngSubmit)="save()"
  >
    <vdr-page-block>
      <vdr-action-bar>
        <vdr-ab-right>
          <button
            *vdrIfPermissions="'UpdateBanner'"
            id="submit"
            type="submit"
            class="button primary"
            [disabled]="hideSubmit(detailForm)"
          >
            {{ (entity ? 'common.update' : 'common.create') | translate }}
          </button>
        </vdr-ab-right>
      </vdr-action-bar>
    </vdr-page-block>
    <vdr-page-detail-layout>
      <vdr-page-detail-sidebar>
        <vdr-card title="Detalhes">
          <div class="form-grid">
            <vdr-form-field
              label="Slug*"
              for="slug"
              [errors]="{ required: 'Slug is required' }"
            >
              <input
                id="slug"
                type="text"
                formControlName="slug"
                [readonly]="!('UpdateBanner' | hasPermission) || onHttpRequest"
                required
              />
            </vdr-form-field>
          </div>
          <vdr-card
            *ngIf="entity$ | async as entity"
            class="mt-4"
          >
            <vdr-page-entity-info [entity]="entity"></vdr-page-entity-info>
          </vdr-card>
        </vdr-card>
      </vdr-page-detail-sidebar>
      <vdr-page-block>
        <vdr-card
          title="{{
            (id
              ? 'grupo-loja.update-banner-item'
              : 'grupo-loja.create-banner-item'
            ) | translate
          }}"
        >
          <form
            *ngIf="entity$ | async as entity"
            class="form"
            [formGroup]="itemsForm"
          >
            <input
              id="id"
              type="hidden"
              required
            />
            <div class="form-grid">
              <vdr-form-field
                label="Link*"
                class="form-grid-span"
                for="link"
                [errors]="{ required: 'Link is required' }"
              >
                <input
                  id="link"
                  type="text"
                  formControlName="link"
                  [readonly]="
                    !('UpdateBanner' | hasPermission) || onHttpRequest
                  "
                  required
                />
              </vdr-form-field>
            </div>
            <div
              class="form-grid"
              style="margin-top: 30px"
            >
              <div class="form-group">
                <label for="end">
                  {{ 'grupo-loja.starts-at-required' | translate }}
                </label>
                <div class="input-row">
                  <vdr-datetime-picker
                    required
                    [ngClass]="{
                      'input-invalid': itemsForm.controls.start.invalid
                    }"
                    formControlName="start"
                  ></vdr-datetime-picker>
                </div>
              </div>

              <div class="form-group">
                <label for="end">
                  {{ 'grupo-loja.ends-at' | translate }}
                </label>
                <div class="input-row">
                  <vdr-datetime-picker
                    [ngClass]="{
                      'input-invalid': itemsForm.controls.end.invalid
                    }"
                    formControlName="end"
                  ></vdr-datetime-picker>
                  <div
                    *ngIf="
                      itemsForm?.controls?.end?.errors?.afterStart === true
                    "
                  >
                    <span class="error-message"
                      >{{ 'grupo-loja.form-ends-before-start' | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-grid"
              style="margin-top: 30px"
            >
              <vdr-form-field
                [label]="'grupo-loja.asset-required' | translate"
                for="asset"
              >
                <image-picker-list
                  name="asset"
                  [multiselect]="false"
                  (asset)="onAsset($event)"
                  (onHttpRequest)="(onHttpRequest)"
                  [assets]="asset"
                  [clear]="clear"
                  [invalid]="itemsForm.controls?.asset?.invalid"
                ></image-picker-list>
              </vdr-form-field>

              <div>
                <vdr-form-field
                  [label]="'grupo-loja.mobile' | translate"
                  for="mobile"
                >
                  <image-picker-list
                    name="mobile"
                    [multiselect]="false"
                    (asset)="onMobile($event)"
                    (onHttpRequest)="(onHttpRequest)"
                    [assets]="mobile"
                    [clear]="clear"
                  ></image-picker-list>
                </vdr-form-field>
              </div>
            </div>
            <div
              class="flex"
              style="margin-top: 30px; justify-content: end"
            >
              <button
                id="clear"
                type="button"
                class="button"
                (click)="clearItemForm()"
                style="margin-right: 10px"
              >
                {{ 'common.cancel' | translate }}
              </button>

              <button
                *vdrIfPermissions="'UpdateBanner'"
                id="submit"
                type="submit"
                class="button primary"
                (click)="addItem()"
                [disabled]="hideSubmit(itemsForm)"
              >
                {{
                  (item ? 'grupo-loja.action-update' : 'grupo-loja.action-add')
                    | translate
                }}
              </button>
            </div>
          </form>
        </vdr-card>

        <vdr-card title="Items">
          <ng-container *ngIf="entity$ | async as entity">
            <banner-item-list
              [id]="entity?.id"
              [update]="update"
              (edit)="editItem($event)"
            ></banner-item-list>
          </ng-container>
        </vdr-card>
      </vdr-page-block>
    </vdr-page-detail-layout>
  </form>
</vdr-page-body>
